import {
	Box,
	Dialog,
	DialogContent,
	IconButton,
	Typography,
} from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";

export type DialogSubscribeDocumentSuccessProps = {
	open: boolean;
	onClose?: () => void;
};
const DialogSubscribeDocumentSuccess: React.FC<
	DialogSubscribeDocumentSuccessProps
> = ({ open, onClose }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			className="p-0"
			scroll="body"
			fullWidth
			maxWidth="xs"
		>
			<Box component="div" className="w-full relative">
				<IconButton
					className="!bg-white/50 absolute right-2 top-2 z-20"
					onClick={onClose}
				>
					<Iconify
						icon="mingcute:close-line"
						width={16}
						className="text-black"
					/>
				</IconButton>
				<Box
					component="div"
					className="dialog-header bg-[#292929] relative p-6 overflow-hidden"
				>
					<Iconify
						icon="line-md:star-alt-filled"
						width={16}
						className="opacity-40 text-white absolute bottom-[30px] left-[18%]"
					/>
					<Box
						component="div"
						className="w-[300px] h-[130px] absolute -right-[80px] bottom-0 rounded-[100%] bg-gradient-to-br from-[#0050FF] to-[#03DDBC] blur-[40px]"
					/>
					<Box
						component="div"
						className="w-[300px] h-[130px] absolute -left-[200px] -bottom-[80px] rounded-[100%] bg-gradient-to-br from-[#0050FF] to-[#03DDBC] blur-[40px]"
					/>
					<Box component="div" className="relative z-10 pb-6">
						<Typography
							component="h3"
							className="text-white text-[22px] md:text-[48px] font-semibold leading-tight"
						>
							Đăng ký <br /> thành công
						</Typography>
					</Box>
				</Box>
				<DialogContent className="p-6">
					<Typography
						component="h4"
						className="text-[24px] font-[600]  text-[#212B36] leading-tight mb-3"
					>
						Bạn đã đăng ký nhận tài liệu
					</Typography>
					<Typography component="p" className="text-[#212B36] text-[14px]">
						Bộ phận chăm sóc học viên sẽ chủ động gửi tài liệu tới bạn trong
						thời gian sớm nhất.
					</Typography>
				</DialogContent>
			</Box>
		</Dialog>
	);
};
export default DialogSubscribeDocumentSuccess;
